import ApiService from 'api-client/ApiService'
// import Bugsnag from 'utils/bugsnag'
import config from 'app-config'
import { RetryVMHARequest, RetryVMHAResponse, VMHAStatusDetails } from './model'

class HaMgr extends ApiService {
  public getClassName() {
    return 'haMgr'
  }

  protected async getEndpoint() {
    return Promise.resolve(config.apiHost)
  }

  get baseUrl(): string {
    return '/hamgr/v1'
  }

  getVhmaForAllClusters = async (clusterList: string[]): Promise<VMHAStatusDetails[]> => {
    if (!clusterList?.length) {
      return []
    }

    const queryParams = new URLSearchParams()
    clusterList.forEach((cluster) => {
      queryParams.append('clusterlist', cluster)
    })

    return this.client.basicGet<VMHAStatusDetails[]>({
      url: `${this.baseUrl}/ha?${queryParams.toString()}`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getVhmaForAllClusters',
      },
    })
  }

  getVMHAStatusForCluster = async (clusterId) => {
    return this.client.basicGet<{ response: VMHAStatusDetails }>({
      url: `${this.baseUrl}/ha/${clusterId}`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getVMHAStatusForCluster',
      },
    })
  }

  getHaConfig = async (aggregateId: string) => {
    return this.client.basicGet({
      url: `${this.baseUrl}/ha/${aggregateId}`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'getHaConfig',
      },
    })
  }

  enableHa = async (aggregateId) => {
    const body = {}
    return this.client.basicPut({
      url: `${this.baseUrl}/ha/${aggregateId}/enable`,
      body,
      options: {
        clsName: this.getClassName(),
        mthdName: 'enableHa',
      },
    })
  }

  disableHa = async (aggregateId) => {
    const body = {}
    return this.client.basicPut({
      url: `${this.baseUrl}/ha/${aggregateId}/disable`,
      body,
      options: {
        clsName: this.getClassName(),
        mthdName: 'disableHa',
      },
    })
  }

  retryVMHA = async (body: RetryVMHARequest): Promise<RetryVMHAResponse> => {
    return this.client.basicPost({
      url: `${this.baseUrl}/vmha/retry_evacuation`,
      body,
      options: {
        clsName: this.getClassName(),
        mthdName: 'retryVMHA',
      },
    })
  }
}

export default HaMgr
